import React from "react";

import { EntityNameTooltip } from "../../container/EntityNameTooltip";
import Country from "../../component/Country";
import { normalize, formatDatetimeString } from "../../formatters";
import {
    getValueFromPath,
    linesOfBusinessAccessor,
    getCountrySource,
} from "../../util";

const getAdvancedSearchColumns = (baseAccessor = "node") => {
    return [
        {
            Header: "ULID",
            id: "entityULID",
            accessor: `${baseAccessor}.key.ulid`,
            filterable: false,
            show: false,
        },
        {
            Header: "Name",
            id: "entityName",
            accessor: `${baseAccessor}.name`,
            Cell: EntityNameTooltip(false),
            filterable: false,
            sortable: true,
            minWidth: 100,
        },
        {
            Header: "Type",
            id: "entityType",
            accessor: `${baseAccessor}.entityType`,
        },
        {
            Header: "Country",
            id: "entityCountry",
            accessor: row => {
                const entity = getValueFromPath(`${baseAccessor}`, row);
                const countrySource = getCountrySource(entity);

                return getValueFromPath(
                    `${countrySource}Address.countryCode`,
                    entity
                );
            },
            Cell: row => <Country.Name>{row.value}</Country.Name>,
            maxWidth: 150,
        },
        {
            Header: "Lines of Business",
            id: "linesOfBusiness",
            accessor: linesOfBusinessAccessor(baseAccessor),
            maxWidth: 250,
        },
        {
            Header: "Screening Level",
            id: "entityScreeningSource",
            accessor: `${baseAccessor}.monitoring`,
            Cell: row => {
                if (!row.value) {
                    return "";
                } else {
                    return normalize(row.value);
                }
            },
        },
        {
            Header: "Active processes",
            id: "entityActiveProcesses",
            accessor: `${baseAccessor}.activeProcesses`,
        },
        {
            Header: "Date Created",
            id: "dateCreated",
            accessor: `${baseAccessor}.createdDate`,
            Cell: row => formatDatetimeString({ str: row.value }),
            maxWidth: 160,
        },
    ];
};

export default getAdvancedSearchColumns;
